import { handleExistingAccountNoOrdersRbi } from 'actions/tools/DecisionTree/RBIActions';

export const noResultConfig = {
  yeti: {
    topText: `YETI's system doesn't populate orders for 1 hour. \nIt is possible it was placed and is still under an hour. Click below for next steps.`,
    buttonText: 'NEXT STEPS',
    path: 'no_search_results',
  },
  rbiValidAccount: {
    topText: `Looks like the customer hasn't placed an order yet \nIf you need to issue a coupon or loyalty points, please click the button below.`,
    buttonText: 'ISSUE COUPON OR POINTS',
    processingAction: handleExistingAccountNoOrdersRbi,
  },
  rbiInvalidAccount: {
    topText: `Please ask the customer for the email \nthey used to create the order using the macro below.`,
    bottomText: `Once you have received a response from the customer, use the updated \ncustomer information to search again.`,
    buttonText: 'NEXT STEPS',
    path: 'no_search_results',
  },
  bigCommerce: {
    buttonText: 'NEXT STEPS',
    path: 'no_search_results',
    topText: `Please ask the customer for the email \nthey used to create the order using the macro below.`,
    bottomText: `Once you have received a response from the customer, use the updated \ncustomer information to search again.`,
  },
  shopify: {
    topText: `Please ask the customer for the email they used to create the \norder and try searching again. You can also try searching by the customer's order number or telephone number.`,
  },
  amazon: {
    topText: `Please find the order number in the conversation and copy/paste it into the search bar.\nIf an error occurred while searching the order, please try again in about 5-10 minutes.\nIf you cannot find the order # or the same error keeps happening, please escalate.`,
  },
  returnsCommon: {
    buttonText: 'NEXT STEPS',
    path: 'no_search_results',
    topText: `Please ask the customer for the order number associated with the return.`,
    bottomText: `Once you have received a response from the customer, use the updated \ncustomer information to search again.`,
  },
};
